import React from "react";

const Star = () => {
  return (
    <svg
      width="40"
      height="38"
      viewBox="0 0 40 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40 14.48L25.62 13.24L20 0L14.38 13.26L0 14.48L10.92 23.94L7.64 38L20 30.54L32.36 38L29.1 23.94L40 14.48ZM20 26.8L12.48 31.34L14.48 22.78L7.84 17.02L16.6 16.26L20 8.2L23.42 16.28L32.18 17.04L25.54 22.8L27.54 31.36L20 26.8Z"
        fill="#7CD1B8"
      />
    </svg>
  );
};

export default Star;
